import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CREATE_SK_LKRL_STORE_NAME, CreateSkLkrlState } from './create-sk-lkrl.state';

/** Select CreateSkLkrl State */
export const selectCreateSkLkrlState = createFeatureSelector<CreateSkLkrlState>(CREATE_SK_LKRL_STORE_NAME);

/** Select CreateSkLkrl isPending status */
export const selectCreateSkLkrlIsPendingStatus = createSelector(selectCreateSkLkrlState, (state) => !!state.isPending);

/** Select CreateSkLkrl isFailure status */
export const selectCreateSkLkrlIsFailureStatus = createSelector(selectCreateSkLkrlState, (state) => !!state.isFailure);
